export const COOKIE_NAME = 'visitor_id';

/** дублируем id, потому что браузер может обрезать куку — см. TTL_DAYS */
export const STORAGE_KEY = 'AbVisitorId';

/**
 * Год — то, что мы просим; сколько проживёт на самом деле, решает браузер.
 *
 * Safari (ITP) режет до семи дней НЕ ТОЛЬКО куку из document.cookie, но и всё
 * скриптовое хранилище, localStorage включительно, если человек семь дней не
 * заходил на сайт. Значит зеркало спасает вернувшегося через день и не спасает
 * вернувшегося через месяц: он получит новый id и может попасть в другое плечо.
 *
 * Лучшего способа удержать анонима нет: сессии у него не бывает (nginx срезает
 * Set-Cookie), а логина мы не требуем. Поэтому граница честно объявлена, а не
 * замаскирована: плечо стабильно в пределах активного использования сайта, и
 * на этом гарантии кончаются. На выводы это влияет мягко — «перебежчики»
 * распределены по плечам одинаково, так что эффект тянется к нулю, а ложной
 * победы такая утечка не создаёт.
 */
export const TTL_DAYS = 365;
